import React, { VFC } from 'react'

import { TermsProps } from './types'
import { TermsModalContent } from './TermsModalContent'

export type PrivacyNoticeProps = TermsProps

export const PrivacyNotice: VFC<PrivacyNoticeProps> = ({ open, setCurrentlyOpenTermsModal }) => {
  return (
    <TermsModalContent
      termsType={'privacyNotice'}
      open={open}
      setCurrentlyOpenTermsModal={setCurrentlyOpenTermsModal}
    />
  )
}
